const BASE = process.env.REACT_APP_BACKEND_URL;

/* Resolve a file URL:
   - absolute URLs (http/https) pass through untouched
   - "/api/..." paths resolve against the backend origin
   - everything else ("/photos/...", "/favicon.png", ...) stays relative — served by the frontend CDN
*/
export const resolveFileUrl = (url) => {
  if (!url) return "";
  if (/^https?:\/\//i.test(url)) return url;
  if (url.startsWith("/api/")) return `${BASE}${url}`;
  return url;
};
